interface Props {
   color?: string;
}

const ArrowLeftIcon: React.FC<Props> = ({ color = "#0D0C21" }) => {
   return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M14.7095 8.12034L10.8294 12.0004L14.7095 15.8804C15.0995 16.2704 15.0995 16.9004 14.7095 17.2904C14.3195 17.6804 13.6894 17.6804 13.2994 17.2904L8.70941 12.7004C8.31941 12.3104 8.31941 11.6804 8.70941 11.2904L13.2994 6.70034C13.6894 6.31034 14.3195 6.31034 14.7095 6.70034C15.0895 7.09034 15.0995 7.73034 14.7095 8.12034Z" fill={color}></path>
   </svg>;
}

export default ArrowLeftIcon;